module.exports = "\r\n\r\n<div class=\"bg\"></div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unavailable/unavailable.component.html
// module id = ./src/app/unavailable/unavailable.component.html
// module chunks = main